import { channelCards } from "@/mocks/civicData";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-600",
  secondary: "bg-secondary-100 text-secondary-600",
};

export default function Channels() {
  return (
    <section
      id="channels"
      className="scroll-mt-24 bg-background-100 py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span>
            正规反映渠道
            <span className="h-px w-8 bg-primary-400"></span>
          </p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            去哪里反映？渠道怎么选
          </h2>
          <p className="mt-4 text-base leading-8 text-foreground-600">
            选择正规、就近、可回访的官方渠道提交线索，是信息得到有效处理的起点。
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {channelCards.map((c) => (
            <article
              key={c.title}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${toneMap[c.tone]}`}
              >
                <i className={c.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {c.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">
                {c.desc}
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}